'use strict';
import { HistoryStatus, HistoryStatusColor } from '../enum/historyStatus';
/**
 * @author Maxim Seredkin
 */
export default function() {
    return {
        restrict: 'A',
        template: require('../view/project-tab-history.html'),
        scope: {
            project: "=myProject"
        },
        controller: ['$scope', "ProjectService", '$routeParams',
            function($scope, ProjectService, $routeParams) {

                $scope.history = [];

                $scope.getHistoryData = () => {
                    if ($scope.project.code == null) return;
                    ProjectService.api.history({ projectId: $scope.project.code }, (data) => {
                        if (!Array.isArray(data._embedded)) return;
                        $scope.history = data._embedded.sort((a,b) => {
                            return b.date.split('.')[0].replace(/[-:T]/g, "") - a.date.split('.')[0].replace(/[-:T]/g, "");
                        });
                    });
                }

                $scope.formatDescription = function(description) {
                    if (!description) return "Отсутствует";
                    return description;
                }

                $scope.formatStatus = function(status) {
                    return HistoryStatus[status];
                }

                $scope.formatDate = function(date) {
                    const options = {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric',
                      };
                    if (!date || typeof date !== "string") return "";
                    const dateObject = new Date(date);
                    return dateObject.toLocaleDateString('ru', options);
                }

                $scope.formatTime = function(date) {
                    if (!date || typeof date !== "string") return "";
                    const dateObject = new Date(date);
                    return dateObject.toLocaleTimeString("ru");
                }

                $scope.isShowFlag = function(status) {
                    return $scope.formatStatus(status) === HistoryStatus.CREATE;
                }

                $scope.getBadgeColor = function(status) {
                    return HistoryStatusColor[status];
                }

                $scope.$watch('project.code', $scope.getHistoryData);
        }],
    };
}
